import React, { useEffect, useState } from "react";
import styles from "./OtherCourses.module.css";
import { Carousel } from "primereact/carousel";
import { SelectButton } from "primereact/selectbutton";

const OtherCourses = (props) => {
  const [isMobile, setIsMobile] = useState(false);
  const [value, setValue] = useState(3);

  const items = [
    { name: "Microcredenciales", value: 3},
    { name: "Certificaciones", value: 1 },
    { name: "Webinarios", value: 2 },
  ];



  let currentItems;

  switch (value) {
    case 1:
      currentItems = props.certifications;
      break;
    case 2:
      currentItems = props.webinars;
      break;
    case 3:
      currentItems = props.asyncCourses; 
      break;
    default:
      currentItems = [];
  }  const filledItems = [...currentItems];

  while (filledItems.length < 4) {
    filledItems.push(null); // Añadir espacios vacíos como `null`
  }  

  useEffect(() => {
    if (currentItems.length < 1) {
      setValue(1); 
    }
  }, []);

  useEffect(() => {
    const buttons = document.querySelectorAll(".p-selectbutton .p-button");
  
    buttons.forEach((button) => {
      const label = button.querySelector(".p-button-label");
      const isPressed = button.getAttribute("aria-pressed") === "true";
  
      if (label?.textContent.trim() === "Microcredenciales") {
        if (!isPressed) {
          button.classList.add("microcredenciales-unselected");
        } else {
          button.classList.remove("microcredenciales-unselected");
        }
      } else {
        button.classList.remove("microcredenciales-unselected");
      }
    });
  }, [value]);

  useEffect(() => {
    if (window.innerWidth <= 480 && !isMobile) {
      setIsMobile(true);
    }
  }, [isMobile]);

  const responsiveOptions = [
    {
      breakpoint: "1400px",
      numVisible: 2,
      numScroll: 1,
    },
    {
      breakpoint: "1199px",
      numVisible: 3,
      numScroll: 1,
    },
    {
      breakpoint: "767px",
      numVisible: 2,
      numScroll: 1,
    },
    {
      breakpoint: "575px",
      numVisible: 1,
      numScroll: 1,
    },
  ];

  

  const certificationsTemplate = (certification) => {
    if (!certification) {
      return <div className={styles.hiddenSlot}></div>;
    }
    return (
      <div className={styles.certificationBox}>
        <img
          onClick={() =>
            (window.location.href = "/courseInfo/" + certification.id)
          }
          src={certification.imageUrl}
          alt="Certification image"
          className={styles.certificationImage}
        />
        <h1
          onClick={() =>
            (window.location.href = "/courseInfo/" + certification.id)
          }
          className={styles.certificationTitle}
        >
          {certification.topic}
        </h1>
        <h2 className={styles.certificationPrice}>
          {certification.price + " US$"}
        </h2>
      </div>
    );
  };

  return (
    <div>
      <div className={styles.otherCourses}>
        <div className="flex justify-content-end align-items-end">
        <div className={value === 3 ? "microcredenciales-select-button" : ""}>
            <SelectButton
              value={value}
              onChange={(e) => setValue(e.value)}
              optionLabel="name"
              options={items}
              className=" w-full mr-2 md:mr-0 "
              allowEmpty={false}
            />
          </div>
        </div>
        <div className={styles.text}>
          <h1 className={styles.title}>Explora otras capacitaciones</h1>
          <h2 className={styles.subTitle}>
            Enfréntate al futuro con la confianza, las habilidades y las
            herramientas para prosperar
          </h2>
          {currentItems.length === 0 ? (
  <div className={styles.emptyState}>
    <div className={styles.iconContainer}>
      <svg 
        className={styles.icon} 
        fill="none" 
        stroke="currentColor" 
        viewBox="0 0 24 24"
      >
        <path 
          strokeLinecap="round" 
          strokeLinejoin="round" 
          strokeWidth={1.5} 
          d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.746 0 3.332.477 4.5 1.253v13C19.832 18.477 18.246 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" 
        />
      </svg>
    </div>
    
    <h3 className={styles.title}>
      No hay cursos disponibles
    </h3>
    
    <p className={styles.description}>
      Actualmente no tenemos cursos disponibles en esta categoría. Por favor, revisa más tarde o explora otras categorías.
    </p>
    
   
    
  </div>
) : (
  <div className={styles.carouselContainer}>

    <Carousel
      value={filledItems}
      itemTemplate={certificationsTemplate}
      numVisible={isMobile ? 1 : 4}
      numScroll={isMobile ? 1 : 4}
      className={styles.carousel}
      responsiveOptions={responsiveOptions}
      showIndicators={false}
      showNavigators={true}
      autoplayInterval={0}
    />
  </div>
)}
        </div>
      </div>
    </div>
  );
};

export default OtherCourses;
